import Vue from 'vue'
import './carousel-swiper.vue'
import '../hero/hero.vue'

export default el => new Vue({
  name: 'Carousel',
  el
})